import React from 'react';
import { useIntl } from 'umi';
import './index.scss';

import MarketCardContext from '@/pages/intelligence/pages/MarketProfile/components/MarketCardContext';
import ProgressBox from '@/pages/intelligence/pages/MarketProfile/TabDetails/components/ProgressBox';
import { testBaseInfo } from '@/pages/intelligence/pages/MarketProfile/_config/_detailTestData';
import defaultCountryImg from '@/pages/intelligence/assets/svg/flag/default.svg';
import { getNationalMap } from '@/pages/intelligence/_config/nationalMap';

export default function HeadCard(props: any) {
  const { countryId, countryFlag, countryName } = props || {};
  const { formatMessage } = useIntl();

  const data = [
    {
      title: formatMessage({ id: 'dbi_market_gdp' }),
      num: testBaseInfo['2022'][countryId]?.gdp_normal,
      text: 'YoY',
      isUp: testBaseInfo['2022'][countryId]?.gdp_normal_precent.indexOf('-') === -1,
      trend: testBaseInfo['2022'][countryId]?.gdp_normal_precent,
    },
    {
      title: formatMessage({ id: 'dbi_market_gdp_per' }),
      num: testBaseInfo['2022'][countryId]?.gdp_capita,
      text: 'YoY',
      isUp: testBaseInfo['2022'][countryId]?.gdp_capita_precent.indexOf('-') === -1,
      trend: testBaseInfo['2022'][countryId]?.gdp_capita_precent,
      tipText: formatMessage({ id: 'dbi_market_gdp_intro' }),
    },
    {
      title: formatMessage({ id: 'dbi_market_total_pop' }),
      num: testBaseInfo['2022'][countryId]?.total_population,
      text: 'YoY',
      isUp: testBaseInfo['2022'][countryId]?.total_population_precent.indexOf('-') === -1,
      trend: testBaseInfo['2022'][countryId]?.total_population_precent,
    },
    {
      title: formatMessage({ id: 'dbi_market_online_pop' }),
      num: testBaseInfo['2022'][countryId]?.online_population,
      text: 'YoY',
      isUp: testBaseInfo['2022'][countryId]?.online_population_precent.indexOf('-') === -1,
      trend: testBaseInfo['2022'][countryId]?.online_population_precent,
    },
  ];

  const progressData1 = [
    {
      text: formatMessage({ id: 'dbi_market_male' }),
      num: testBaseInfo['2022'][countryId]?.Gender.Male,
      color: '#5086F3',
    },
    {
      text: formatMessage({ id: 'dbi_market_female' }),
      num: testBaseInfo['2022'][countryId]?.Gender.Female,
      color: '#5EC8F1',
    },
  ];

  const progressData2 = [
    {
      text: '10~20',
      num: testBaseInfo['2022'][countryId]?.['Age Combined']['10-20'],
      color: '#5086F3',
    },
    {
      text: '21~35',
      num: testBaseInfo['2022'][countryId]?.['Age Combined']['21-35'],
      color: '#5EC8F1',
    },
    {
      text: '36~50',
      num: testBaseInfo['2022'][countryId]?.['Age Combined']['36-50'],
      color: '#69D19C',
    },
    {
      text: '51~65',
      num: testBaseInfo['2022'][countryId]?.['Age Combined']['51-65'],
      color: '#F5D242',
    },
  ];

  return (
    <div className="dbi-market-overview-headcard">
      <div className="overview-headcard-l">
        <img src={getNationalMap(testBaseInfo['2022'][countryId]?.name)} />
      </div>
      <div className="overview-headcard-r">
        <div className="overview-headcard-header">
          {countryFlag ? <img src={countryFlag} /> : <img src={defaultCountryImg} />}
          <span>{countryName}</span>
        </div>
        <div className="overview-headcard-wrap">
          <div className="overview-headcard-data">
            {data.map((item: any, index: any) => {
              return (
                <>
                  <MarketCardContext
                    data={item}
                    key={index}
                    tipText={item.tipText}
                    isHasYoY={false}
                  />
                  {index == 1 ? <div className="overview-headcard-data-line" /> : ''}
                </>
              );
            })}
          </div>
          <div className="overview-headcard-content">
            <div className="overview-headcard-progress">
              <div className="overview-headcard-progress-list">
                {testBaseInfo['2022'][countryId]?.Gender ? (
                  progressData1.map((item: any, index: any) => {
                    return <ProgressBox data={item} key={index} />;
                  })
                ) : (
                  <></>
                )}
              </div>
              <div className="overview-headcard-progress-txt">
                <div className="progress-txt-text">
                  {formatMessage({ id: 'dbi_market_total_popular' })}
                </div>
                <div className="progress-txt-info">
                  {formatMessage({ id: 'dbi_market_gender' })}
                </div>
              </div>
            </div>
            <div className="overview-headcard-progress">
              <div className="overview-headcard-progress-list">
                {progressData2.map((item: any, index: any) => {
                  return <ProgressBox data={item} key={index} />;
                })}
              </div>
              <div className="overview-headcard-progress-txt">
                <div className="progress-txt-text">
                  {formatMessage({ id: 'dbi_market_online_population' })}
                </div>
                <div className="progress-txt-info">{formatMessage({ id: 'dbi_market_age' })}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
